import {
  QueryClient,
  QueryClientProvider as TanstackQueryClientProvider,
} from "@tanstack/react-query";

import { retryQuery } from "@punto/frontend-shared/utils/query-retry";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: retryQuery,
    },
  },
});

export const QueryClientProvider = ({
  children,
}: {
  children?: React.ReactNode;
}) => (
  <TanstackQueryClientProvider client={queryClient}>
    {children}
  </TanstackQueryClientProvider>
);
